import styled from 'styled-components/native'

import { Box } from 'widgets/Box'
import { Button } from 'widgets/Button'

export const ImageContainer = styled(Box)`
  flex-basis: unset;
`

export const ImageControlsContainer = styled(Box)`
  margin-top: ${({ theme }) => theme.spacing.lg}px;
`

export const ButtonContainer = styled(Box)`
  border-top: 2px solid ${({ theme }) => theme.colors.grey};
  padding: 16px;
  width: 100%;
`

export const ActionButton = styled(Button)`
  width: 45%;
`
export const IconContainer = styled(Box)`
  position: absolute;
  left: 70%;
`
